import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import theme from 'live/services/theme'
import { COLUMNS, HEADERS } from './config'

const Table = styled.table`
    width: 100%;

    thead th {
        border-bottom: solid 1px ${theme['input-borders']};
        cursor: pointer;
        position: sticky;
        top: -13px;
        background: white;
        body.dark-theme & {
            color: #fff;
            background-color: ${theme['dark-light']};
        }
    }

    td,
    th {
        padding: 10px;
        width: 100px;
    }

    tbody tr {
        background-color: #fff;
        body.dark-theme & {
            background-color: ${theme['text-color']};
        }
    }

    tbody tr:nth-child(odd) {
        background-color: #f4f5f6;
        body.dark-theme & {
            background-color: #303a4f;
        }
    }

    tbody::-webkit-scrollbar {
        width: 4px;
    }

    tbody::-webkit-scrollbar-track {
        box-shadow: inset 0 0 0px rgba(0, 0, 0, 0.3);
    }
    tbody::-webkit-scrollbar-thumb {
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
        height: 4px;
    }
`

export default function TableChart({ state }): JSX.Element {
    const { uom, surveys } = state
    const ref = useRef<HTMLElement>()
    useEffect(() => {
        if (ref.current && ref.current.parentNode) {
            ref.current.parentNode.style.overflowY = 'auto'
        }
    }, [])

    return (
        <Table ref={ref}>
            <thead>
                <tr>
                    {COLUMNS.map(col => (
                        <th key={col}>
                            {HEADERS[col]} {uom[col] ? `(${uom[col]})` : null}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {surveys.map(survey => (
                    <tr key={survey.tvd}>
                        {COLUMNS.map(col => (
                            <td key={col}>{survey[col]}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    )
}
